import MainTopMenu from 'src/components/layout/MainLayout/MainTopMenu'
import React, { ReactNode } from 'react'
import MainBottomSheet from 'src/components/layout/MainLayout/MainBottomSheet'

const MainPageLayout = ({ children }: { children: ReactNode }) => {
  return (
    <React.Fragment>
      <MainTopMenu />
      {children}
      <MainBottomSheet />
    </React.Fragment>
  )
}
export default MainPageLayout
